var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-power"},[_c('div',{staticClass:"title"},[_vm._v("基本信息")]),_c('div',{staticClass:"dry-power-content"},[_c('div',{staticClass:"xinxi"},[_c('img',{staticClass:"imgBox",attrs:{"src":_vm.xinxiData.img}}),_c('div',{staticClass:"pBox"},[_c('p',[_vm._v(" "+_vm._s(_vm.xinxiData.content)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }